import { apiClient } from '@core/api/ApiClientFactory';
import type { RfidTag, RfidTagFilter, PaginatedItems, DuplicateRfidTag } from './types';

export const rfidTagService = {
    // RFID Tags
    async loadRfidTags(payload: any): Promise<PaginatedItems<RfidTag>> {
        try {
            const response = await apiClient.post<PaginatedItems<RfidTag>>('rfidTag/all', payload);
            return response.data;
        } catch (error) {
            console.error('[RfidTagService] Error loading rfid tags:', error);
            throw error;
        }
    },

    async checkRfidTagDuplicates(formData: FormData): Promise<DuplicateRfidTag[]> {
        try {
            const response = await apiClient.post<DuplicateRfidTag[]>('rfidTag/checkDuplicates', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return response.data;
        } catch (error) {
            console.error('[RfidTagService] Error checking RFID tag duplicates:', error);
            throw error;
        }
    },

    async importRfidTags(formData: FormData): Promise<void> {
        try {
            await apiClient.post('rfidTag/import', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return;
        } catch (error) {
            console.error('[RfidTagService] Error importing rfid tags:', error);
            throw error;
        }
    },

    // RFID Tag Filters
    async loadRfidTagFilters(payload: any): Promise<PaginatedItems<RfidTagFilter>> {
        try {
            const response = await apiClient.post('rfidTagFilter/all', payload);
            return response.data;
        } catch (error) {
            console.error('[RfidTagService] Error loading rfid tag filters:', error);
            throw error;
        }
    },

    async createRfidTagFilter(data: RfidTagFilter): Promise<void> {
        try {
            await apiClient.post('rfidtagfilter', data);
            return;
        } catch (error) {
            console.error('[RfidTagService] Error creating rfid tag filter:', error);
            throw error;
        }
    },

    async updateRfidTagFilter(data: RfidTagFilter): Promise<void> {
        try {
            await apiClient.put(`rfidtagfilter/${data.id}`, data);
            return;
        } catch (error) {
            console.error('[RfidTagService] Error updating rfid tag filter:', error);
            throw error;
        }
    },

    async deleteRfidTagFilter(id: string): Promise<void> {
        try {
            await apiClient.delete(`rfidTagFilter/${id}`);
            return;
        } catch (error) {
            console.error('[RfidTagService] Error deleting rfid tag filter:', error);
            throw error;
        }
    }
};
